import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { env } from '@/env'

import { GetCampaigns } from '../types'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  rifa: GetCampaigns | null
}

export function CampaignDetailsModal({ open, onOpenChange, rifa }: Props) {
  if (!rifa) return null

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-center text-2xl font-bold">
            {rifa.campanha.titulo}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 text-center">
          <img
            src={`${env.VITE_API_URL}${rifa.campanha.imagem}`}
            alt="img"
            className="w-full rounded-lg object-cover"
          />

          <p className="text-muted-foreground text-sm">
            {rifa.campanha.descricao}
          </p>
          <div className="text-primary text-2xl font-extrabold">
            R$ {Number(rifa.campanha.titulo_Valor).toFixed(2).replace('.', ',')}
          </div>

          {/* Prêmios */}
          {rifa.premios.length > 0 && (
            <div className="space-y-2 text-center">
              <h3 className="text-md font-semibold text-green-400">
                🎁 Prêmios
              </h3>
              <ul className="text-md text-muted-foreground list-none space-y-1 text-sm">
                {rifa.premios.map((premio) => (
                  <li key={premio.id}>
                    <span className="font-medium">{premio.posicao}º lugar</span>{' '}
                    – {premio.descricao}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Promoções */}
          {rifa.promocoes.length > 0 && (
            <div className="mt-4 rounded-xl p-4 text-center">
              <h3 className="text-md font-semibold text-blue-400">
                🔥 Promoções
              </h3>
              <ul className="text-md text-muted-foreground mt-2 space-y-1 text-sm font-medium">
                {rifa.promocoes.map((promo) => (
                  <li key={promo.id}>
                    {promo.quantidade} números por R${' '}
                    {promo.valor.toFixed(2).replace('.', ',')}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
